import { useEffect, useState } from 'react';
import {
  DEFAULT_SYS_DIC_FORM,
  SYS_DIC_STATUS_OPTIONS,
  rowToSysDicForm,
} from './sysDicConstants';

export default function SysDictionaryEditModal({
  open,
  row,
  onClose,
  onSubmit,
  submitting,
}) {
  const isEdit = Boolean(row?.id);
  const [form, setForm] = useState(DEFAULT_SYS_DIC_FORM);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setForm(rowToSysDicForm(row));
      setError('');
    }
  }, [open, row?.id]);

  if (!open) {
    return null;
  }

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!form.dicKey?.trim()) {
      setError('請填寫 Key');
      return;
    }
    setError('');
    await onSubmit(form);
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>{isEdit ? '修改數據字典' : '新增數據字典'}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            {error ? <p className="form-message form-message--error">{error}</p> : null}
            <div className="form-grid">
              <div className="form-field form-field--full">
                <label htmlFor="sysDicKey">Key</label>
                <input
                  id="sysDicKey"
                  type="text"
                  value={form.dicKey}
                  disabled={isEdit}
                  onChange={(e) => updateField('dicKey', e.target.value)}
                  placeholder="請輸入欄位名 Key"
                />
              </div>
              <div className="form-field form-field--full">
                <label htmlFor="sysDicValue">Value</label>
                <textarea
                  id="sysDicValue"
                  rows={4}
                  value={form.dicValue}
                  onChange={(e) => updateField('dicValue', e.target.value)}
                  placeholder="請輸入 Value"
                />
              </div>
              <div className="form-field form-field--full">
                <label htmlFor="sysDicRemark">備註</label>
                <input
                  id="sysDicRemark"
                  type="text"
                  value={form.remark}
                  onChange={(e) => updateField('remark', e.target.value)}
                />
              </div>
              <div className="form-field form-field--full">
                <span className="form-field__label">狀態</span>
                <div className="product-type-radios">
                  {SYS_DIC_STATUS_OPTIONS.map((option) => (
                    <label key={option.value} className="checkbox-inline">
                      <input
                        type="radio"
                        checked={form.status === option.value}
                        onChange={() => updateField('status', option.value)}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="admin-modal__footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              關閉
            </button>
            <button type="submit" className="btn btn-primary" disabled={submitting}>
              {submitting ? '提交中…' : '提交'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
